import model from '../models-v2/crm/system-balance';

export default [
  {
    path: '/system-balances',
    name: 'crm-system-balances',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../pages/system-balance/SystemBalanceTopRightSection.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Saldo systemowe', url: '/system-balances' },
      ],
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
];
